const readOnly = ["Read"];
const readWrite = ["Read", "Write"];
const hidden: string[] = [];

export const FormPermissions = {
    merchantdetails: {
        venue_name: {
            SQUARE: readOnly,
        },
        address_postcode: {
            SQUARE: readOnly,
        },
        location_name: {
            SQUARE: readOnly,
        },
        address_country: {
            SQUARE: readOnly,
        },
        currency_id: {
            SQUARE: readOnly,
        },
        language_id: {
            SQUARE: readOnly,
        },
        time_zone_id: {
            SQUARE: readOnly,
        },
    },
    profile: {
        url_instagram: {
            SQUARE: readOnly,
        },
        url_facebook: {
            SQUARE: readOnly
        },
        url_twitter: {
            SQUARE: readOnly
        }
    },
    subcategorydialog: {
        subcategory_name: {
            SQUARE: readOnly,
        },
        delete: {
            SQUARE: hidden
        },
        category_id: {
            SQUARE: readOnly
        },
        enabled: {
            SQUARE: readWrite
        }
    },
    extrasdialog: {
        name_public: {
            SQUARE: readOnly,
        },
        name_internal: {
            SQUARE: readOnly,
        },
        delete: {
            SQUARE: hidden
        },
        category_id: {
            SQUARE: readOnly
        },
        quantity_min: {
            SQUARE: readOnly
        },
        quantity_max: {
            SQUARE: readOnly
        },
        extras_list: {
            SQUARE: readOnly
        }
    },
    productdialog: {

        name_public: {
            SQUARE: readOnly, EPOSNOW: readOnly, YOELLO: readWrite
        },
        name_internal: {
            SQUARE: readOnly, EPOSNOW: readOnly, YOELLO: readWrite
        },
        subcategory_id: {
            SQUARE: readOnly, EPOSNOW: readOnly, YOELLO: readWrite
        },
        item_vat_type: {
            SQUARE: readOnly, EPOSNOW: readOnly, YOELLO: readWrite
        },
        preference_tags: {
            SQUARE: hidden, EPOSNOW: hidden, YOELLO: readWrite
        },
        pricing_options: {
            SQUARE: readOnly, EPOSNOW: readOnly, YOELLO: readWrite
        },
        pricing_options_extras: {
            SQUARE: readOnly, EPOSNOW: readOnly, YOELLO: readWrite
        },
        delete: {
            SQUARE: hidden, EPOSNOW: hidden, YOELLO: readWrite
        },
        extra_items: {
            SQUARE: readOnly, EPOSNOW: readOnly, YOELLO: readWrite
        },
        item_taxes: {
            SQUARE: hidden, EPOSNOW: readOnly, YOELLO: readWrite
        }
    }
}

export const ComponentPermissions = {
    newProductButton: {
        SQUARE: hidden, EPOSNOW: hidden, YOELLO: readWrite
    },
    newSubcatButton: {
        SQUARE: hidden, EPOSNOW: hidden, YOELLO: readWrite
    },
    newPrefButton: {
        SQUARE: hidden, EPOSNOW: hidden, YOELLO: readWrite
    },
    newExtraButton: {
        SQUARE: hidden, EPOSNOW: hidden, YOELLO: readWrite
    },
    newVenueButton: {
        SQUARE: hidden, EPOSNOW: hidden, YOELLO: readWrite
    }
}
